// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeEventAlertKindsGetBody = {
  eventId: string;
};

export type typeEventAlertKindsGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    eventId: string;
    kinds: {
      key: string;
      label: string;
      isOnByDefault: boolean;
      description?: string;
    }[];
  };
};

export type typeEventAlertKindsGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventAlertKindsGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventAlertKindsGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaEventAlertKindsGetBody = {
  type: "object",
  properties: { eventId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["eventId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createEventAlertKindsGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaEventAlertKindsGetBody);
  }

  return async function postEventAlertKindsGet(
    payload: typeEventAlertKindsGetBody,
  ): Promise<
    typeEventAlertKindsGetOutput200 | typeEventAlertKindsGetOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postEventAlertKindsGet" failed before calling the network. #78e7033d0f42`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#78e7033d0f42" },
        },
        data: null,
      } as typeEventAlertKindsGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/event/alert-kinds-get`,
      httpMethod: "POST",
      options,
    })) as typeEventAlertKindsGetOutput200 | typeEventAlertKindsGetOutput400;
  };
}
